<template>
  <div class="language-switchover" style="display:none">
    <label>
      <input v-show="notShow" v-model="lang" :value="languageZh" type="radio" name="language">
      <div :class="{'language-sure': lang===languageZh}" class="language-chose">中</div>
    </label>
    <label>
      <input v-show="notShow" v-model="lang" :value="languageEn" type="radio" name="language">
      <div :class="{'language-sure': lang===languageEn}" class="language-chose">E</div>
    </label>
  </div>
</template>
<script>
import { durationTime } from '@/utils/const'
import { languageZh, languageEn } from '@/utils/const'

export default {
  name: 'LangSelect',
  data() {
    return {
      languageZh,
      languageEn,
      notShow: false,
      language: '',
      userInfo:
      {
        languageId: '',
        userId: '',
        factoryId: '',
        assemblyLineId: ''
      }
    }
  },
  computed: {
    lang: {
      get: function() {
        return this.$store.getters.language
      },
      set: function(selectLanguage) {
        this.$store.state.app.language = selectLanguage
        this.language = selectLanguage
        this.$i18n.locale = this.language
        this.$store.dispatch('app/SetLanguage', this.language).then(() => {
          this.$message({
            message: this.$t('langselect.switchsuccess'),
            type: 'success',
            duration: durationTime
          })
          if (this.$store.getters.userid) {
            this.userInfo.languageId = this.$store.getters.language
            this.userInfo.userId = this.$store.getters.userid
            this.userInfo.factoryId = this.$store.getters.factoryid
            this.userInfo.assemblyLineId = this.$store.getters.assemblylineid
            // this.$store.dispatch('SetMenuList', this.userInfo).then(() => {
            // }).catch(error => {
            //   console.log('langselect error:' + error)
            // })
          }
        }).catch(() => {
          this.$message({
            message: this.$t('langselect.switchfail'),
            type: 'error',
            duration: durationTime
          })
        })
      }
    }
  },
  created() {
    this.language = this.$store.getters.language
  },
  methods: {
  }
}
</script>
<style scoped>
  .language-switchover {
    height: auto;
    margin: 10px;
    display: inline-flex;
    float: right;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content:  flex-start;
    border: 1px solid #fff;
  }
  .language-chose {
    height: auto;
    width: 26px;
    line-height: 26px;
    text-align: center;
    color: #fff;
  }
  @media screen and (max-width: 1400px) {
    .language-chose {
      height: auto;
      width: 22px;
      font-size: 12px;
    }
  }
  .language-sure {
    background-color: #fff;
    color: #000;
  }
</style>



// WEBPACK FOOTER //
// src/components/langselect/index.vue